var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "addEditRules",
          attrs: {
            model: _vm.editForm,
            "label-position": "top",
            size: "small",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("routes.flowName"),
                        prop: "flowName",
                        rules: {
                          required: true,
                          message: this.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "formTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "remote-method": _vm.getFlowDirectList,
                          },
                          on: {
                            change: _vm.changeFlowName,
                            "visible-change": function ($event) {
                              return _vm.getFlowDirectList()
                            },
                          },
                          model: {
                            value: _vm.editForm.flowName,
                            callback: function ($$v) {
                              _vm.$set(_vm.editForm, "flowName", $$v)
                            },
                            expression: "editForm.flowName",
                          },
                        },
                        _vm._l(_vm.flowDirectNameList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.flowDirectName,
                              value: item.flowDirectName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("routes.departureTransferCenter"),
                        prop: "startTransitId",
                        rules: {
                          required: true,
                          message: this.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.changeStartTransit },
                          model: {
                            value: _vm.editForm.startTransitId,
                            callback: function ($$v) {
                              _vm.$set(_vm.editForm, "startTransitId", $$v)
                            },
                            expression: "editForm.startTransitId",
                          },
                        },
                        _vm._l(_vm.transferList, function (item) {
                          return _c("el-option", {
                            key: item.departTransferCenterId,
                            attrs: {
                              label: item.departTransferCenterName,
                              value: item.departTransferCenterId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("routes.下一站流向"),
                        prop: "nextId",
                        rules: {
                          required: true,
                          message: this.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.changeNextId },
                          model: {
                            value: _vm.editForm.nextId,
                            callback: function ($$v) {
                              _vm.$set(_vm.editForm, "nextId", $$v)
                            },
                            expression: "editForm.nextId",
                          },
                        },
                        _vm._l(_vm.flowDirectNextList, function (item) {
                          return _c("el-option", {
                            key: item.nextSiteId,
                            attrs: {
                              label: item.nextSiteName,
                              value: item.nextSiteId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("routes.发车时间"),
                        prop: "departTime",
                        rules: {
                          required: true,
                          message: this.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-time-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          format: "HH:mm",
                          "value-format": "HH:mm",
                        },
                        model: {
                          value: _vm.editForm.departTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.editForm, "departTime", $$v)
                          },
                          expression: "editForm.departTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        "font-weight": "bold",
                        color: "#696b6f",
                        "margin-bottom": "3px",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#DD4A68",
                            "margin-right": "3px",
                          },
                        },
                        [_vm._v("*")]
                      ),
                      _vm._v(
                        " " + _vm._s(_vm.$t("routes.DepartureTimeRange")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "160px", display: "inline-block" },
                      attrs: {
                        label: "",
                        prop: "startDateType",
                        rules: {
                          required: true,
                          message: this.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.editForm.startDateType,
                            callback: function ($$v) {
                              _vm.$set(_vm.editForm, "startDateType", $$v)
                            },
                            expression: "editForm.startDateType",
                          },
                        },
                        [
                          _c("el-option", {
                            key: 1,
                            attrs: {
                              label: _vm.$t("collectionCenter.sameDay"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            key: 2,
                            attrs: {
                              label: _vm.$t("routes.PreviousDay"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "190px", display: "inline-block" },
                      attrs: {
                        label: "",
                        prop: "startTime",
                        rules: {
                          required: true,
                          validator: _vm.dateRangeRules,
                          start: _vm.editForm.startTime,
                          end: _vm.editForm.endTime,
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          format: "HH:mm",
                          "value-format": "HH:mm",
                        },
                        model: {
                          value: _vm.editForm.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.editForm, "startTime", $$v)
                          },
                          expression: "editForm.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "10px",
                        "text-align": "center",
                        display: "inline-block",
                        "margin-left": "30px",
                      },
                    },
                    [_vm._v("~")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "160px", display: "inline-block" },
                      attrs: {
                        label: "",
                        prop: "endDateType",
                        rules: {
                          required: true,
                          message: this.$t("GlobalSetObj.pleaseChoose"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.editForm.endDateType,
                            callback: function ($$v) {
                              _vm.$set(_vm.editForm, "endDateType", $$v)
                            },
                            expression: "editForm.endDateType",
                          },
                        },
                        [
                          _c("el-option", {
                            key: 1,
                            attrs: {
                              label: _vm.$t("collectionCenter.sameDay"),
                              value: 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "190px", display: "inline-block" },
                      attrs: {
                        label: "",
                        prop: "endTime",
                        rules: {
                          required: true,
                          validator: _vm.dateRangeRules,
                          start: _vm.editForm.startTime,
                          end: _vm.editForm.endTime,
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          format: "HH:mm",
                          "value-format": "HH:mm",
                        },
                        model: {
                          value: _vm.editForm.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.editForm, "endTime", $$v)
                          },
                          expression: "editForm.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }